import {getBlnAuthTokenObject, getOrganizationKey} from '@bluedrop-learning-networks/frontend-utils';
import {LogLevel, faro, getWebInstrumentations, initializeFaro} from '@grafana/faro-web-sdk';
import {TracingInstrumentation} from '@grafana/faro-web-tracing';

export function initializeGrafana(appURL: string, traceHeaderUrl: string) {
	const organizationKey = getOrganizationKey();
	const {userId} = getBlnAuthTokenObject() || {};
	const instrumentationOptions = {
		propagateTraceHeaderCorsUrls: [new RegExp(traceHeaderUrl, 'u')],
	};
	initializeFaro({
		url: appURL,
		app: {
			name: 'portal-one',
		},
		instrumentations: [
			// Mandatory, overwriting the instrumentations array would cause the default instrumentations to be omitted
			...getWebInstrumentations(),
			// Initialization of the tracing package.
			// This packages is optional because it increases the bundle size noticeably.
			// Only add it if you want tracing data.
			new TracingInstrumentation({instrumentationOptions}),
		],
		sessionTracking: {
			enabled: true,
			persistent: false,
			onSessionChange: (oldSession) => {
				const sessionId = oldSession?.id || 'null';
				faro.api.pushLog(['Previous session ID:', sessionId], {level: LogLevel.INFO});
			},
		},
		user: {
			id: `${userId}`,
			attributes: {
				organizationKey,
			},
		},
	});
}
